import React, { useState, useEffect } from "react";
import axios from "axios";
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import DynamicForm from '../common/DynamicForm';
import LoaderComponent from "../../../libraries/loader/loader";
import { Fetchexecutequery, Fetchheaderdata,Fetchupdatequery } from '../../../services/process/BRS1/brsService7';
import { CreateData} from '../../../services/process/process_data/process_data';
import { Icon } from 'semantic-ui-react';

function DepartmentCreation() {
  const [formData, setFormData] = useState({});
  const [userCredentials] = useState(JSON.parse(sessionStorage.getItem("userCredentials")));
  const [fields, setFields] = useState(null);
  const [rowData, setRowData] = useState([]);
  const [columnDefs, setColumnDefs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchText, setSearchText] = useState('');
  const [error, setError] = useState(null);
  const [editMode, setEditMode] = useState(false); // State to track if in edit mode
  const [filterconditions,setFilterconditions] =  useState([{"is_active" : 1,"entity_id" : userCredentials.selectedentity,"tenant_id": userCredentials.tenants_id,"group_id": userCredentials.groups_id}]);
  
  useEffect(() => {
    fetchFieldInfo1();
    fetchFieldInfo2();
  }, []);

  const getFormattedDate = () => {
    const currentDate = new Date();
    return currentDate.toISOString().slice(0, 19).replace("T", " ");
  };

  const formatColumnName = (name) =>
    name.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());

  const fetchFieldInfo1 = async () => {
    const payload = { headerconfig_id: 37,"filterconditions":filterconditions };

    try {
      const FileUploadCredentials = Fetchheaderdata();
      const response = await axios.post(
        FileUploadCredentials[1], // URL
        payload,                  // Payload
        FileUploadCredentials[0]   // Headers or Credentials
      );

      const data = response.data;
      if (data.fields && data.fields.length > 0) {
        const columns = data.fields.map((field) => ({
          headerName: formatColumnName(field.columnName),
          field: field.columnName,
        sortable: true,
        filter: true,
          resizable: true,
          width: 250
        }));
        columns.push({
          headerName: "Edit",
          field: "edit",
          cellRendererFramework: (params) => (
            <Icon
              name="edit"
              style={{ cursor: 'pointer' }}
              onClick={() => handleEditClick(params.data)}
            />
          ),
          width: 100, // Set width for the edit column
        });

        setColumnDefs(columns);
        setFields(data.fields);
        console.log("fields fetched",columns)
      }
    } catch (error) {
      console.error("Error fetching field info:", error);
      setError("Error fetching fields data");
    }
    setLoading(false);
  };

  const handleEditClick = (row) => {
    console.log("Editing row:", row);
    setFormData(row); // Populate formData with row data for editing
    setEditMode(true); // Set edit mode to true
  };

  const fetchFieldInfo2 = async () => {
    const payload = { query: `SELECT id,site_code, cost_centre_code,site_name,location, channel, asm_name FROM paymentsuat.sbi_cost_centre_details where entity_id = ${userCredentials.selectedentity} and is_active=1;` };

    try {
      const FileUploadCredentials = Fetchexecutequery();
      const response = await axios.post(
        FileUploadCredentials[1],
        payload,
        FileUploadCredentials[0]
      );

      const data = response.data;
      if (data && data.length > 0) {
        const columns = Object.keys(data[0]).map((key) => ({
          headerName: formatColumnName(key),
          field: key,
        }));

        setRowData(data);
        console.log("data fetched",data)
      }
    } catch (error) {
      console.error("Error fetching department data:", error);
      setError("Error fetching department data");
    }
  };

  const createPayload = (database, table, formData) => ({
    database,
    table,
    formData,
  });

  const handleCreate = () => {
      const formattedDate = getFormattedDate();
      
      // Combine form data with additional fields
      const updatedFormData = {
        ...formData,
        created_on: formattedDate,
        last_updated_on: formattedDate,
        entity_id: userCredentials.selectedentity,
        created_by: userCredentials.user_id,
        modified_by: userCredentials.user_id,
        last_updated_by: userCredentials.user_name,
      };

    const payload = createPayload('paymentsuat', 'sbi_cost_centre_details', updatedFormData);

    const FileUploadCredentials = CreateData();

    axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
      .then(response => {
        console.log("Create response:", response);
        setFormData({});
        fetchFieldInfo2();
        // window.location.reload();
      })
      .catch((error) => {
        console.error("Error creating data:", error);
        setError("Error creating data");
      });
  };

  const handleUpdate = () => {

    const formattedDate = getFormattedDate();

    console.log('formData',formData,formData.id)
    const updatedFormData = { ...formData,
        last_updated_on: formattedDate,
        modified_by: userCredentials.user_id,
        last_updated_by: userCredentials.user_name
 };

    // Remove primary_id from the copied formData
    delete updatedFormData.primary_id;
    const payload = {
      schema_name: 'paymentsuat',
      table: 'sbi_cost_centre_details',
      set_column : updatedFormData,
      'where' : [{"id":formData.id}]
    };

    const FileUploadCredentials = Fetchupdatequery();

    axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
      .then(response => {
        console.log("Update response:", response);
        setEditMode(false); // Reset edit mode after updating
        window.location.reload();
      })
      .catch((error) => {
        console.error("Error updating data:", error);
        setError("Error updating data");
      });
  };

  const handleInputChange = (name, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const onFilterTextChange = (event) => {
    const { value } = event.target;
    setSearchText(value);
  };


  const handleSubmit = (e) => {
    e.preventDefault();
    if (editMode) {
      handleUpdate();
    } else {
      handleCreate();
    }
  };

 if (loading) return <LoaderComponent loaderOpen={true}/>;

  return (
    <div>
      <h2 className="pt-1 pb-1 text-center" style={{ color: "#4969ab", fontSize: '18px' }}>
        Cost Center Details
      </h2>

      {error && <div style={{ color: "red" }}>{error}</div>}

      <DynamicForm fields={fields} formData={formData} onInputChange={handleInputChange}/>
	      <div className="submit-row" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center',margin:'2px',paddingRight:'10px' }}>
  {/* Search Input at the Left End */}
  <input
    className="search-input"
    type="text"
    placeholder="Search..."
    value={searchText}
    onChange={onFilterTextChange}
    style={{
      width: '30%',
      backgroundColor: 'white',
      marginRight: '8px',
      marginTop: '0',
      padding: '8px',
      borderRadius: '4px',
      border: '1px solid #ced4da',
    }}
  />

  {/* Submit Button at the Right End */}
  <button
    type="submit"
    className="submit-btn"
    onClick={handleSubmit}
  >
    Submit
  </button>
      </div>

      <div
        style={{
          display: 'flex',
          justifyContent: 'center'
        }}
      >
    {(!columnDefs.length || !rowData.length) ? (
      <div>Loading or no data available</div>
    ) : (
      <div
        className="ag-theme-alpine"
        style={{
              overflowX: 'auto',
              overflowY: 'auto',
              borderRadius: '10px',
              width: `${columnDefs.length * 250}px`,
              maxWidth: '100%',
              height : '315px',
              margin : '10px'
         }}

      >
        <AgGridReact
          columnDefs={columnDefs}
          rowData={rowData}
          quickFilterText={searchText}
          filter={true} // Enable filtering on the grid level
          animateRows={true}
          pagination={true}
          paginationPageSize={6}
          enableCellTextSelection= {true}
        />

      </div>
    )}
        </div>


    </div>
  );
}

export default DepartmentCreation;
